// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#addFilesModal .selectPlant {
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 0px;
}
#addFilesModal p {
  margin-bottom: 0.64rem;
}
#addFilesModal input:disabled + label {
  opacity: 50%;
}
#addFilesModal .icon-add-files {
  padding-right: 5px;
}
#addFilesModal .btn-add-files {
  display: inline-flex;
  float: right;
}
#addFilesModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#addFilesModal .container.radio {
  width: fit-content !important;
  padding: 0 50px;
}
#addFilesModal .checkmark {
  margin-left: -26px;
  margin-top: 3px;
}
#addFilesModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#addFilesModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#addFilesModal .btn-link:focus {
  text-decoration: none;
}
#addFilesModal .btn-secondary {
  border-radius: 30px;
  min-width: 115px;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#addFilesModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
@media (min-width: 2024px) {
#addFilesModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#addFilesModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#addFilesModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#addFilesModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#addFilesModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#addFilesModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
